export type Result<D, E extends Error = Error> =
  | {
      ok: true;
      data: D;
    }
  | {
      ok: false;
      error: E;
    };

export const ok = <D>(data: D): {ok: true; data: D} => ({
  ok: true,
  data,
});

export const err = <E extends Error>(error: E): Result<never, E> => ({
  ok: false,
  error,
});

export const unwrap = <D, E extends Error>(result: Result<D, E>): D => {
  if (!result.ok) {
    throw result.error;
  }

  return result.data;
};
